
<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
    <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
</div>

<div class="row">
    <div class="col-sm-6">
        <button type="button" class="btn-guardar" mat-raised-button (click)="descargar()" style="padding-left: 15px;" *ngIf="insAuto.estado === 3">
            <i class="fas fa-print"></i> Descargar
        </button>

        <a class="btn-guardar" mat-raised-button style="padding-top: 0px;margin-left: 25px;color: #F5BB3F;background: #FFF;text-align: center;width: 250px;" >
            <p class="statusname" *ngIf="insAuto.estado === 1">estado: No iniciado</p>
            <p class="statusname" *ngIf="insAuto.estado === 2">estado: Iniciado</p>
            <p class="statusname" *ngIf="insAuto.estado === 3">estado: Terminado</p>
        </a>
   </div>

   <div class="col-sm-6" style="display: flex; justify-content: flex-end;">
        <a class="btn-guardar" *ngIf="(insAuto.estado === 1 || insAuto.estado == 2)" mat-raised-button (click)="finalizar()" style="padding-left: 15px;" >
            Finalizar
        </a>  
        <a class="btn-guardar" *ngIf="(insAuto.estado === 1 || insAuto.estado == 2)" mat-raised-button (click)="guardar()" style="margin-left: 15px; background-color: #597CEE; margin-left: 15px;"  >
            <i class="fas fa-save"></i> Guardar
        </a>
    </div>
</div>


<div class="customers">
    <div class="card" style="padding: 1rem;">
        <div class="card-body" style="padding: 20px;">
            <div class="row">
                <div class="d-flex justify-content-between">
                    <div>
                        <p style="text-align: left;
                            font: normal normal bold 26px/26px Montserrat;
                            letter-spacing: 0px;
                            color: #00B09E;
                            opacity: 1;">Instrumento de Autoevaluación de la gestión integral de las Unidades Educativas Alternativas</p>
                    </div>
                    <div class="" style="text-align: left;">
                       
                    </div>
                </div>
                <div class="d-flex justify-content-between">
                    <div>
                       
                    </div>
                    <div class="" style="text-align: left;">
                        <div class="d-flex justify-content-end" style="background: #F6F6F6 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1;
                        padding: 15px;
                        ">
                            <p class="info-label">JARDÍN INFANTIL: </p>

                            <p class="info-data">{{dataJardin.jardin}}</p>

                            <p class="info-label">CÓDIGO: </p>

                            <p class="info-data">{{dataJardin.rbd}}</p>

                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-12">
                    <p style="font: normal normal 600 14px/18px Montserrat;
                    letter-spacing: 0px;
                    color: #30374B;
                    text-transform: uppercase;
                    display: inline-block;
                    opacity: 1;">
                        INTRODUCIÓN:
                    </p>
                    <br>
                    <p style="text-align: justify;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;">
                    El Sistema Educativo Chileno ha elaborado una serie de documentos que, complementados  entre sí, son un referente técnico pedagógico para desarrollar prácticas educativas con foco en  el aprendizaje de niñas y niños. A continuación, se precisan énfasis de cada uno de ellos.
                    Para esto, contamos con el Sistema Nacional de Aseguramiento de la Calidad en Educación  Parvularia, que contempla un conjunto de instrumentos y medidas dirigidos a promover una  mejora continua de los aprendizajes y fomentar las capacidades de los establecimientos  educacionales del país.     
                    </p>
                    <br>
                    <p style="text-align: justify;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;">
                    Este sistema, define los referentes del nivel: Bases Curriculares de la Educación Parvularia, Marco  para la Buena Enseñanza de la Educación Parvularia, los Estándares Indicativos de Desempeño  de la Educación Parvularia, y el Marco para la Buena Dirección de la Educación Parvularia, para  profundizar en cada uno de ellos, las y los invitamos a revisar la Bitácora de la Unidad Educativa.     
                    </p>
                    <br>
                    <p style="text-align: justify;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;">
                    Los Estándares Indicativos de Desempeño son el marco orientador para analizar nuestra  gestión, y con ello avanzar en la toma de decisiones oportunas, pertinentes y con ello brindar más y  mejores oportunidades de aprendizaje para niños y niñas. Su propósito es apoyarnos y orientarnos,  nos permitirá identificar puntos críticos y oportunidades para movilizar la mejora continua. 
                    Estos estándares son la ruta, el camino que se nos invita a caminar como nivel educativo, el cómo  caminamos, más lento, más despacio, a saltitos, dependerá de nuestras definiciones, y para ello  requerimos mirarnos, reflexionarnos, evaluarnos, 
                    Para ello, y con el propósito de acompañar y complementar el proceso de autoevaluación  de la gestión integral de las Modalidades Educativas Alternativas de la JUNJI, se dispone este  documento en formato editable, este instrumento les permitirá registrar acciones asociadas a la  gestión integral.                          
                    </p>

                </div>
            </div>
            <div class="row">
                <div class="div-obs" style="border: #84b2f5 1px solid;color: #FFF;background: #A0BFEC;text-align: justify;width: 100%;">
                   <p>
                        La invitación es que, junto a la comunidad educativa, incluyendo a asesores y asesoras que las
                        acompañan, reflexionen sus procesos, desde una mirada constructiva, respetuosa, conversada,
                        analicen cada uno de los procesos que nos invitan a mirar los estándares y marquen con una x
                        donde se identifican (débil, incipiente, satisfactorio, avanzado) es una invitación a autoevaluarnos,
                        a evaluar el quehacer pedagógico, este proceso nos permitirá tomar decisiones, las que plasmarán
                        en la generación de sus Planes de Mejoramiento Educativo (PME),
                   </p>
                </div>
            </div>
            <div class="row mb-3">
                <p>
                    <b>Este instrumento para la autoevaluación de la gestión educativa integral</b> aborda las cinco
                    dimensiones a diagnosticar
                </p>             
            </div>
            <div class="row mb-3" style="padding-left: 30px;">
                <ul>
                    <li>1.- Dimensión Liderazgo</li>
                    <li>2.- Dimensión Familia y Comunidad</li>
                    <li>3.- Dimensión Gestión Pedagógica</li>
                    <li>4.- Dimensión Bienestar Integral</li>
                    <li>5.- Dimensión Gestión de Recursos</li>
                </ul>       
            </div>

            <div class="row mb-3">
                <p>
                    A continuación, las y los invitamos a realizar este proceso profesional y humano, siempre es bueno
                    detenernos y observarnos, y qué mejor que con el gran propósito de generar oportunidades de
                    aprendizajes diversas y gozosas para las infancias.
                </p>   
            </div>

            <div class="row mb-3">
                <p>
                    Recomendamos consideren para este proceso, lo siguiente:
                </p>   
            </div>

            <div class="row mb-3" style="padding-left: 30px;">
                <ul>
                    <li>· Lean las orientaciones para la autoevaluación de la gestión educativa integral de la unidad educativa, este documento les comparte el para qué realizar este proceso.</li>
                    <li>· Organicen sus tiempos para este proceso, el equipo asesor les orientará en este proceso.</li>
                    <li>· Analicen las orientaciones y este instrumento</li>
                    <li>· Revisen su bitácora, esta las guiará a mirar su gestión integral.</li>
                    <li>· Este instrumento es editable, por lo que, si cuentan con un computador, pueden completarlo directamente.</li>
                    <li>· Analicen cada una de las dimensiones a la luz de sus prácticas y procesos, encuéntrense en las categorías y marquen conscientemente en la que cree que está.</li>
                    <li>· Finalmente se presenta un cuadro SÍNTESIS FINAL DEL PROCESO AUTOEVALUATIVO, en donde podrán identificar la posición en la escala de cada una de las 13 Subdimensiones.</li>
                    <li>· Una vez que hayan finalizado este proceso, plasmen sus propósitos y metas en el Plan de Mejoramiento Educativo (PME).</li>
                </ul>       
            </div>

            <div class="row mb-3">
                <button type="button" class="btn-guardar" mat-raised-button (click)="nivelesDesarrollo()" style="width: 260px;">
                    <i class="fas fa-info"></i> Niveles de Desarrollo
                </button>
            </div>

            <br>

            <!--div class="row" *ngIf="insAuto.tipo === null">
                <div class="div-obs" style="border: #84b2f5 1px solid;color: #FFF;background: #A0BFEC;text-align: justify;width: 100%;">
                    <div class="row">
                        <div class="col-sm-8 d-flex justify-content-center align-items-center">
                            <p>
                                Favor selecciona una opción para cumplir con el Instrumento
                            </p>
                        </div>
                        <div class="col-sm-4 ">
                            <a class="btn-status"  *ngIf="!simulacion" (click)="insAuto.tipo = 1" style="margin-bottom: 0px; border: #84b2f5 1px solid;margin-left: 25px;color: #A0BFEC;background: #FFF;text-align: center;width: 250px;display: inline-block;cursor: pointer; margin-top: 15px;" >
                                Llenar Antecedentes
                            </a>  
                            <a class="btn-status" *ngIf="!simulacion" (click)="insAuto.tipo = 2" style="margin-bottom: 0px; border: #84b2f5 1px solid;margin-left: 25px;color: #A0BFEC;background: #FFF;text-align: center;width: 250px;display: inline-block;cursor: pointer; margin-top: 15px;" >
                                Cargar Documento
                            </a>  
                        </div>
                    </div>
                 </div>
            </div-->

            <!--div class="row" *ngIf="insAuto.tipo === 1 && insAuto.estado != 3"-->
                <div class="col-sm-12">
                    <div *ngFor="let dimensionData of insAuto.dimensiones; let indice=index">
                        <app-ins-autoevaluacion-dimension [dimensionData]="dimensionData" [simulacion]="simulacion" [isModificable]="isModificable"></app-ins-autoevaluacion-dimension>
                    </div> 
                </div>
            <!--/div-->


            <!--div class="row" *ngIf="insAuto.tipo === 2 && insAuto.estado != 3">
                <div class="col-sm-12">
                    <div class="modal-body" style="padding: 0px 50px;" width="100%">
                        <div class="row">
                            <div class="row row-form mt-3 mb-3">
                                
                                <div class="col-sm-6">
                                    <label>Archivo PDF</label>
                                </div>
                                <div class="col-sm-6">
                                    <input class="form-control" accept="application/pdf" type="file" #inputFile (change)="cambioArchivo($event)">
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div class="modal-footer">
                        <button type="button" class="btn btn-send mb-4" style="width: 180px;background-color: #597CEE; height: 38px;color: #FFFFFF;" (click)="subirArchivo($event)"> Enviar y Finalizar</button>
                    </div>
                </div>
            </div-->
            <br>
        </div>
    </div>
    
    <ng-template #modalInstrumento let-modal class="modal-dialog modal-xl">
        <div class="modal-header" style="padding: 0px " width="100%">
            <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Instrumento Autoevaluación</h5>
            <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" style="padding: 0px;" width="100%">
            <iframe [src]="urlSafe" frameborder="0" width="100%" style="min-height: 700px;" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
        </div>
    </ng-template>

    <ng-template #modalNiveles let-modal class="modal-dialog modal-xl">
        <div class="modal-header">
            <h5 id="modalTitleUser" class="titulo-card-amarillo" style="margin: 25px">NIVELES DE DESARROLLO</h5>
            <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body">
            <table class="table table-sm table-bordered" style="margin-bottom: 10px;">
                <tr style="text-align: center;">
                    <th style="font-size: 10pt; border: solid 1px #ffffff; background-color: #818181; color: #ffffff; width: 10%;"></th>
                    <th style="font-size: 10pt; border: solid 1px #ffffff; background-color: #818181; color: #ffffff; width: 35%;">NIVEL DE DESARROLLO</th>
                    <th style="font-size: 10pt; border: solid 1px #ffffff; background-color: #818181; color: #ffffff; width: 50%;">DESCRIPCIÓN</th>

                </tr>

                <tr>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: center;">1</td>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: center;">Débil</td>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: left; display: block;">
                        No se presentan las prácticas o procesos, o se realizan de manera aislada en
                        el centro educativo.
                        <br>
                        No están dadas las condiciones para que las prácticas o procesos sean
                        implementados.
                    </td>
                </tr>

                <tr>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: center;">2</td>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: center;">Incipiente</td>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: left; display: block;">
                        Las prácticas o procesos se presentan ocasionalmente pero no de manera
                        sistemática, ni en todos los niveles.
                        <br>
                        Estas aún no se han institucionalizado en prácticas o procesos formales que
                        sean parte de la cultura educativa.
                    </td>
                </tr>

                <tr>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: center;">3</td>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: center;">Satisfactorio</td>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: left; display: block;">
                        Las prácticas o procesos son frecuentes en el centro educativo
                        implementándose de manera estable y sistemática en todos los niveles.
                        <br>
                        Están institucionalizadas en prácticas o procesos formales como parte de la
                        cultura educativa.
                    </td>
                </tr>

                <tr>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: center;">4</td>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: center;">Avanzado</td>
                    <td style="font-size: 10pt; border: solid 1px #ffffff; background-color: #cccccd; text-align: left; display: block;">
                        Las prácticas y procesos se presentan de manera sistemática en todos los
                        niveles del centro educativo.
                        <br>
                        El centro educativo está en búsqueda constante de prácticas innovadoras
                        y desafiantes y están articulada con su plan anual o PEI<sup>5</sup>, y con las metas
                        institucionales.
                        <br>
                        El centro es un líder educativo en la investigación-acción al contar con
                        prácticas o procesos sobre los cuales ha investigado y luego desarrollado
                        prácticas y gestiones pertinentes para su comunidad educativa. Los avances e
                        innovaciones son difundidas tanto interna como externamente.
                    </td>
                </tr>
            </table>
        </div>
    </ng-template>
</div>